<template>
    <div :class="['page scores',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: infoFontColor }">
            <div class="score-box">
                <div class="score-row header">
                    <p>Date</p>
                    <p>Score</p>
                </div>
                <div class="score-row" v-for="score in scores.filter(s => typeof s.score == 'number')">
                    <p>{{ typeof score.date == 'number' ? format(score.date,'EEEE dd/MM/yy HH:mm') : '' }}</p>
                    <p>{{ score.score }}</p>
                </div>
            </div>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';
import { format } from 'date-fns';

export default {
    name: 'scores',
    mixins: [ pageOn ],
    computed: {
        pages () { return this.$store.state.pages },
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        infoFontColor () { return this.$store.state.infoFontColor },
        scores () { return this.$store.state.scores }
    },
    data () {
        return {
            format
        }
    },
    components: {
        VHeader
    },
    mounted () {

    },
    methods: {
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
        
    }
}

</script>

<style lang="scss">
.score-box {
    width: 90%;
    margin: 5%;
    .score-row {
        &:nth-child(1) {
            p:nth-child(1) { text-align: center; }
        }
        font-size: 18px;
        display: grid;
        grid-template-columns: 1fr 0.3fr;
        text-align: right;
        p:nth-child(2) { text-align:center }
    }
}
</style>